/** Resolve stored file references to backend URLs (payment proofs, etc.). */

const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

function isAllowedExternalUrl(url) {
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:' && u.protocol !== 'http:') return false;
    if (BACKEND) {
      const backendOrigin = new URL(BACKEND).origin;
      if (u.origin === backendOrigin) return true;
    }
    const bucket = (process.env.REACT_APP_S3_BUCKET_URL || '').replace(/\/$/, '');
    if (bucket && url.startsWith(bucket)) return true;
    return false;
  } catch {
    return false;
  }
}

function resolveStoredPath(stored, buildApiPath) {
  if (!stored || typeof stored !== 'string') return '';
  const s = stored.trim();
  if (s.startsWith('blob:')) return s;
  if (s.startsWith('http://') || s.startsWith('https://')) {
    return isAllowedExternalUrl(s) ? s : '';
  }
  return buildApiPath(s);
}

export function paymentProofHref(stored) {
  return resolveStoredPath(stored, (s) => {
    if (s.startsWith('/api/files/payment-proofs/')) {
      return `${BACKEND}${s}`;
    }
    if (s.startsWith('/uploads/payment_proofs/')) {
      const fname = encodeURIComponent(s.split('/').pop() || '');
      return `${BACKEND}/api/files/payment-proofs/${fname}`;
    }
    if (s.startsWith('payment_proofs/')) {
      const fname = encodeURIComponent(s.split('/').pop() || '');
      return `${BACKEND}/api/files/payment-proofs/${fname}`;
    }
    return `${BACKEND}${s.startsWith('/') ? s : `/${s}`}`;
  });
}

export function agentKycHref(stored) {
  return resolveStoredPath(stored, (s) => {
    if (s.startsWith('/api/files/agent-kyc/')) {
      return `${BACKEND}${s}`;
    }
    if (s.startsWith('/uploads/agent_kyc/')) {
      const fname = encodeURIComponent(s.split('/').pop() || '');
      return `${BACKEND}/api/files/agent-kyc/${fname}`;
    }
    if (s.startsWith('agent_kyc/')) {
      const fname = encodeURIComponent(s.split('/').pop() || '');
      return `${BACKEND}/api/files/agent-kyc/${fname}`;
    }
    return `${BACKEND}${s.startsWith('/') ? s : `/${s}`}`;
  });
}

export function isPdfUrl(url) {
  return /\.pdf$/i.test((url || '').split('?')[0]);
}
